import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/Home.css";
import axios from "axios";
import AdLeft from "./AdLeft";
import AdRight from "./AdRight";
import { handleSearch } from "../utils/search";
import { getDaysDiff } from "../utils/dateUtils";
import { checkSessionUser } from "../utils/auth";
import { handleNewsClickUtil } from "../utils/newsClick";
import { fetchRankingUtil } from "../utils/ranking";
import Footer from "./Footer";
import Header from "./Header";

axios.defaults.withCredentials = true;

function Home() {
  const navigate = useNavigate();
  const [profileBox, setProfileBox] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [urlInput, setUrlInput] = useState("");
  const [id, setId] = useState("");
  const [posts, setPosts] = useState([]);
  const [msg, setMsg] = useState("");
  const postsPerPage = 5;
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rankings, setRankings] = useState([]);
  const [showList, setShowList] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [period, setPeriod] = useState("daily");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [newsData, setNewsData] = useState(null);
  const [showChat, setShowChat] = useState(false);

  // ------------------ 0) 앱 진입 시 토큰을 Axios 전역 헤더에 적용 ------------------
  useEffect(() => {
    const t = localStorage.getItem("jwtToken");
    if (t) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    } else {
      delete axios.defaults.headers.common["Authorization"];
    }
  }, []);

  // ------------------ 1) 세션 유저 로드 ------------------
  useEffect(() => {
    checkSessionUser(setUserInfo, setId, setIsLoggedIn);
    // ✅ OAuth2 로그인 시 username을 로컬스토리지에서 복구
    const savedUsername = localStorage.getItem("username");
    if (savedUsername) {
      setId(savedUsername);
    }
  }, []);

  // ------------------ 3) 안전 파생값 ------------------
  const isLogin = !!userInfo?.username;
  const safePosts = Array.isArray(posts) ? posts : [];
  const safeRankings = Array.isArray(rankings) ? rankings : [];
  const visibleNewsCount = safePosts.length;
  const pageNumbers = Array.from(
    { length: Math.max(0, totalPages) },
    (_, index) => index + 1,
  );
  const daysDiff = newsData?.date
    ? getDaysDiff(new Date(), newsData.date)
    : null;

  // ------------------ 4) 배경 높이 동적 조절(널가드) ------------------
  // useEffect(() => {
  //     const background = document.querySelector(".Home-img");
  //     if (!background) return;
  //
  //     const baseHeight = 1000;
  //     const extraPerNews = 220;
  //
  //     if (!isLogin) {
  //         background.style.height = `${baseHeight}px`;
  //     } else {
  //         const height =
  //             visibleNewsCount <= 1
  //                 ? baseHeight
  //                 : baseHeight + (visibleNewsCount - 1) * extraPerNews;
  //         background.style.height = `${height}px`;
  //     }
  // }, [visibleNewsCount, isLogin]);

  // ------------------ 5) 랭킹 로드 + 안전한 롤링 ------------------
  useEffect(() => {
    fetchRankingUtil(period, setRankings, setLoading, setError);
  }, [period]);

  useEffect(() => {
    if (safeRankings.length === 0) return;
    const intervalId = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % Math.min(safeRankings.length, 10));
    }, 5000);
    return () => clearInterval(intervalId);
  }, [safeRankings]);

  // ------------------ 6) 클릭 핸들러 ------------------
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const handleNewsClick = (e, url, username) => {
    e.preventDefault();
    handleNewsClickUtil(url, username, navigate);
  };

  return (
    <div className="Home-container">
      <Header />
      {/* 좌측 광고 */}
      <div className="AdLeft-container">
        <AdLeft />
      </div>
      {/* 우측 광고 */}
      <div className="AdRight-container">
        <AdRight />
      </div>

      {/* 메인 컨텐츠 */}
      <div className="Home-main">
        <div className="Home-img"></div>
        <header className="Home-header">
          <div className="Home-home-container">
            <div className="Home-title-container">
              <button
                className="Home-home-button"
                type="button"
                onClick={() => navigate("/")}
              >
                <img
                  className="Home-home-button-img"
                  src="/snake.png"
                  alt="타이틀 이미지"
                />
              </button>
            </div>
          </div>

          <p className="Home-body">
            정보를 원하는 기사의 URL을
            <br />
            입력해 보세요.
          </p>
          <div className="Home-search-container">
            <div className="Home-Search">
              <input
                id="Home-search-input"
                placeholder="뉴스 URL을 입력하세요."
                value={urlInput}
                onChange={(e) => setUrlInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch(urlInput, id, navigate); // ✅ 엔터로 검색 실행
                  }
                }}
              />
              <img
                className="Home-search-img"
                src="/icon.png"
                alt="돋보기"
                onClick={() => handleSearch(urlInput, id, navigate)}
              />
            </div>
            <div className="Home-period">
              <div className="ranking-period-select">
                <button
                  className={`daily ${period === "daily" ? "active" : ""}`}
                  onClick={() => setPeriod("daily")}
                >
                  일간
                </button>
                <button
                  className={`weekly ${period === "weekly" ? "active" : ""}`}
                  onClick={() => setPeriod("weekly")}
                >
                  주간
                </button>
                <button
                  className={`monthly ${period === "monthly" ? "active" : ""}`}
                  onClick={() => setPeriod("monthly")}
                >
                  월간
                </button>
              </div>

              <div className="Home-real-time-search">
                <div
                  className="top-company"
                  onClick={() => setShowList((prev) => !prev)}
                >
                  실시간 {currentIndex + 1}위:{" "}
                  {loading
                    ? "불러오는 중..."
                    : rankings[currentIndex]?.company || "데이터 없음"}
                </div>

                {showList && (
                  <ul className="ranking-list">
                    {error ? (
                      <li>{error}</li>
                    ) : (
                      rankings.slice(0, 10).map((item, index) => (
                        <li key={index}>
                          {index + 1}위:{" "}
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (!isLoggedIn) {
                                alert("로그인 시 사용 가능한 기능입니다.");
                                return;
                              }
                              if (item.company && item.company !== "—") {
                                navigate(
                                  `/${encodeURIComponent(item.company)}`,
                                  { state: { companyName: item.company } },
                                );
                              }
                            }}
                          >
                            {item.company}
                          </span>{" "}
                          ({item.companyCount}회)
                        </li>
                      ))
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>

          {!isLogin ? (
            <p className="Home-tail">
              로그인해서 전에 검색했던 내용을 다시 확인하세요!
            </p>
          ) : (
            <p className="Home-tail">
              History를 눌러 전에 검색했던 내용을 확인하세요!
            </p>
          )}
        </header>
      </div>

      <Footer />
    </div>
  );
}

export default Home;
